module.exports = __webpack_public_path__ + "static/media/nr.66dd1573.svg";